export default __webpack_public_path__ + "static/media/desktop.d1afbe57.png";